<div class="resource-policy-linking-container">
  <div class="entity-toolbar">
    <div class="left-tools">
      <div class="page-title-section">
        <h2><i class="fas fa-link"></i>Resource Policy Linking</h2>
        <p *ngIf="classId" class="class-id-info">Managing quota and cleanup policy settings for Class ID: <strong>{{ classId }}</strong></p>
      </div>
    </div>
    <div class="toolbar-actions">
      <button mat-stroked-button routerLink="/policy/policy-template-list">
        <i class="fas fa-arrow-left"></i>Back to Policies
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p>Loading class details...</p>
  </div>

  <!-- Class Details Section -->
  <div *ngIf="!loading && classData" class="class-details-section">
    <div class="section-header">
      <h3>Class Details</h3>
    </div>
    <div class="class-details-content">
      <div class="four-col-row">
        <div>
          <label>Class Name:</label>
          <span>{{ classData.name || 'N/A' }}</span>
        </div>
        <div>
          <label>Course Name:</label>
          <span>{{ classData.trainingSchedule?.course?.name || 'N/A' }}</span>
        </div>
        <div>
          <label>Course Code:</label>
          <span>{{ classData.trainingSchedule?.course?.code || 'N/A' }}</span>
        </div>
        <div>
          <label>Status:</label>
          <span class="status-badge" [ngClass]="'status-' + classData.status?.toLowerCase()">{{ classData.status }}</span>
        </div>
      </div>
      <div class="four-col-row">
        <div>
          <label>Stage:</label>
          <span>{{ classData.stage }}</span>
        </div>
        <div>
          <label>Training Title:</label>
          <span>{{ classData.trainingSchedule?.title || 'N/A' }}</span>
        </div>
        <div style="grid-column: span 2;">
          <label>Provider:</label>
          <span>{{ classData.trainingSchedule?.course?.provider || 'N/A' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Resource Policy Configuration Section -->
  <div *ngIf="!loading && classData" class="resource-policy-section">
    <div class="resource-sections-container">

      <!-- VM Resource Section -->
      <div *ngIf="hasVMResources" class="resource-section vm-section">
        <div class="section-title">
          <h4><i class="fas fa-desktop"></i>VM Resources</h4>
        </div>
        <div class="resource-form">
          <div class="form-row">
            <div>
              <label>Resource Type:</label>
              <span class="type-badge badge-vm">
                <i class="fas fa-desktop"></i>
                VM
              </span>
            </div>
          </div>
          <div class="form-row">
            <div>
              <label>Resource Template:</label>
              <div class="resource-template-container">
                <div *ngFor="let vm of getVMResources()" class="resource-template-item">
                  <span class="template-name">{{ vm.name }}</span>
                  <button type="button" mat-stroked-button color="primary" (click)="viewResourceDetails(vm)">
                    <i class="fas fa-eye"></i> View
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div>
              <label>Cleanup Policy Template: <span class="text-danger">*</span></label>
              <div class="policy-selection-container">
                <select class="cleanup-policy-select" [(ngModel)]="selectedVMPolicy">
                  <option value="">Select Policy</option>
                  <option *ngFor="let policy of vmPolicies" [value]="policy.Id">{{ policy.PolicyName }}</option>
                </select>
                <div class="policy-actions">
                  <button type="button" mat-stroked-button color="primary" (click)="openAddVMPolicyModal()">
                    <i class="fas fa-plus"></i> New
                  </button>
                  <button
                    type="button"
                    mat-stroked-button
                    color="primary"
                    (click)="viewVMPolicyDetails()"
                    *ngIf="selectedVMPolicy"
                    [disabled]="!selectedVMPolicy">
                    <i class="fas fa-eye"></i> View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Subscription Resource Section -->
      <div *ngIf="hasSubscriptionResources" class="resource-section subscription-section">
        <div class="section-title">
          <h4><i class="fas fa-cloud"></i>Subscription Resources</h4>
        </div>
        <div class="resource-form">
          <div class="form-row">
            <div>
              <label>Resource Type:</label>
              <span class="type-badge badge-subscription">
                <i class="fas fa-cloud"></i>
                Subscription
              </span>
            </div>
          </div>
          <div class="form-row">
            <div>
              <label>Resource Template:</label>
              <div class="resource-template-container">
                <div *ngFor="let sub of getSubscriptionResources()" class="resource-template-item">
                  <span class="template-name">{{ sub.name }}</span>
                  <button type="button" mat-stroked-button color="primary" (click)="viewResourceDetails(sub)">
                    <i class="fas fa-eye"></i> View
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div>
              <label>Quota limit per subscription:</label>
              <div class="quota-input-container">
                <input type="number" class="quota-input" [(ngModel)]="subscriptionQuotaLimit" min="1">
                <select class="currency-select" [(ngModel)]="selectedCurrency">
                  <option *ngFor="let currency of availableCurrencies" [value]="currency">{{ currency }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div>
              <label>Cleanup Policy Template: <span class="text-danger">*</span></label>
              <div class="policy-selection-container">
                <select class="cleanup-policy-select" [(ngModel)]="selectedSubscriptionPolicy">
                  <option value="">Select Policy</option>
                  <option *ngFor="let policy of subscriptionPolicies" [value]="policy.Id">{{ policy.PolicyName }}</option>
                </select>
                <div class="policy-actions">
                  <button type="button" mat-stroked-button color="primary" (click)="openAddSubscriptionPolicyModal()">
                    <i class="fas fa-plus"></i> New
                  </button>
                  <button
                    type="button"
                    mat-stroked-button
                    color="primary"
                    (click)="viewSubscriptionPolicyDetails()"
                    *ngIf="selectedSubscriptionPolicy"
                    [disabled]="!selectedSubscriptionPolicy">
                    <i class="fas fa-eye"></i> View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Confirm Button -->
    <div class="confirm-section">
      <button
        type="button"
        mat-flat-button
        color="primary"
        class="confirm-btn"
        (click)="onConfirm()"
        [disabled]="!isFormValid() || savingPolicy"
      >
        <div class="spinner-border spinner-border-sm" role="status" *ngIf="savingPolicy">
          <span class="sr-only">Loading...</span>
        </div>
        <i class="fas fa-check-circle" *ngIf="!savingPolicy"></i>
        {{ savingPolicy ? 'Saving...' : 'Confirm' }}
      </button>
    </div>
  </div>

  <!-- No Class Data State -->
  <div *ngIf="!loading && !classData && classId" class="no-data-container">
    <div class="alert alert-warning">
      <i class="fa fa-exclamation-triangle"></i>
      Unable to load class details for Class ID: {{ classId }}
    </div>
  </div>

  <!-- No Class ID State -->
  <div *ngIf="!classId" class="no-class-container">
    <div class="alert alert-info">
      <i class="fa fa-info-circle"></i>
      No class specified. Please select a class to manage resource policy linking.
    </div>
  </div>
</div>

<!-- VM Policy Template Modal -->
<div class="modal-overlay" *ngIf="showAddVMPolicyModal" (click)="closeAddVMPolicyModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 style="color:white"><i class="fas fa-plus-circle"></i> Create New VM Policy Template</h3>
      <button class="close-button" (click)="closeAddVMPolicyModal()" title="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <app-deletion-policy
        [resourceType]="'vm'"
        [defaultTab]="'vm'"
        (policyCreated)="onVMPolicyCreated()">
      </app-deletion-policy>
    </div>
  </div>
</div>

<!-- Subscription Policy Template Modal -->
<div class="modal-overlay" *ngIf="showAddSubscriptionPolicyModal" (click)="closeAddSubscriptionPolicyModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 style="color:white"><i class="fas fa-plus-circle"></i> Create New Subscription Policy Template</h3>
      <button class="close-button" (click)="closeAddSubscriptionPolicyModal()" title="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <app-deletion-policy
        [resourceType]="'subscription'"
        [defaultTab]="'subscription'"
        (policyCreated)="onSubscriptionPolicyCreated()">
      </app-deletion-policy>
    </div>
  </div>
</div>

<!-- View Policy Details Modal -->
<div class="modal-overlay" *ngIf="showViewDetailsModal" (click)="closeViewDetailsModal()">
  <div class="modal-content policy-details-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 style="color:white">
        <i class="fas fa-eye"></i>
        <span *ngIf="selectedPolicyDetails">{{selectedPolicyDetails.PolicyName || 'Policy Details'}}</span>
        <span *ngIf="!selectedPolicyDetails">Policy Details</span>
      </h3>
      <button class="close-button" (click)="closeViewDetailsModal()" title="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="loadingDetails" class="loading-container">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <p>Loading policy details...</p>
      </div>
      <div *ngIf="!loadingDetails && selectedPolicyDetails" class="policy-details-content">
        <app-view-policy-details [policyDetails]="selectedPolicyDetails"></app-view-policy-details>
      </div>
      <div *ngIf="!loadingDetails && !selectedPolicyDetails" class="error-message">
        <i class="fas fa-exclamation-triangle"></i>
        <p>Failed to load policy details. Please try again.</p>
      </div>
    </div>
  </div>
</div>

<!-- Resource Details Modal -->
<div class="modal-overlay" *ngIf="showResourceDetailsModal" (click)="closeResourceDetailsModal()">
  <div class="modal-content resource-details-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 style="color:white">
        <i class="fas fa-server"></i>
        <span *ngIf="selectedResourceDetails">{{selectedResourceDetails.data.TemplateDetailsData.templateName || 'Resource Details'}}</span>
        <span *ngIf="!selectedResourceDetails">Resource Details</span>
      </h3>
      <button class="close-button" (click)="closeResourceDetailsModal()" title="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="loadingResourceDetails" class="loading-container">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <p>Loading resource details...</p>
      </div>
      <div *ngIf="!loadingResourceDetails && selectedResourceDetails" class="resource-details-content">

        <!-- Template Details Section -->
        <div class="details-section">
          <h5 class="section-title">
            <i class="fas fa-file-alt"></i>
            Template Details
          </h5>
          <div class="details-grid">
            <div class="detail-item">
              <label>Template Name:</label>
              <span>{{ selectedResourceDetails.data.TemplateDetailsData.templateName }}</span>
            </div>
            <div class="detail-item">
              <label>Description:</label>
              <span>{{ selectedResourceDetails.data.TemplateDetailsData.templateDescription }}</span>
            </div>
            <div class="detail-item">
              <label>Status:</label>
              <span class="status-badge" [ngClass]="'status-' + selectedResourceDetails.status">{{ selectedResourceDetails.status }}</span>
            </div>
          </div>
        </div>

        <!-- Cloud Provider Details Section -->
        <div class="details-section">
          <h5 class="section-title">
            <i class="fas fa-cloud"></i>
            Cloud Provider Details
          </h5>
          <div class="details-grid">
            <div class="detail-item">
              <label>Provider:</label>
              <span class="provider-badge">{{ selectedResourceDetails.data.CloudProviderData.provider | uppercase }}</span>
            </div>
            <div class="detail-item">
              <label>Region:</label>
              <span>{{ selectedResourceDetails.data.CloudProviderData.region }}</span>
            </div>
            <div class="detail-item">
              <label>VM Size:</label>
              <span>{{ selectedResourceDetails.data.CloudProviderData.size }}</span>
            </div>
            <div class="detail-item">
              <label>Storage Type:</label>
              <span>{{ selectedResourceDetails.data.CloudProviderData.storage }}</span>
            </div>
            <div class="detail-item">
              <label>Max Count:</label>
              <span>{{ selectedResourceDetails.data.CloudProviderData.maxCount }}</span>
            </div>
          </div>
        </div>

        <!-- Software Details Section -->
        <div class="details-section">
          <h5 class="section-title">
            <i class="fas fa-cogs"></i>
            Software Configuration
          </h5>
          <div class="details-grid">
            <div class="detail-item">
              <label>Operating System:</label>
              <span>{{ selectedResourceDetails.data.SoftwareData.os | titlecase }}</span>
            </div>
            <div class="detail-item">
              <label>OS Version:</label>
              <span>{{ selectedResourceDetails.data.SoftwareData.osVersion }}</span>
            </div>
          </div>

          <!-- SDKs Section -->
          <div class="software-section" *ngIf="selectedResourceDetails.data.SoftwareData.sdks.length > 0">
            <h6><i class="fas fa-code"></i> SDKs</h6>
            <div class="software-badges">
              <span class="software-badge sdk-badge" *ngFor="let sdk of selectedResourceDetails.data.SoftwareData.sdks">
                {{ sdk }}
              </span>
            </div>
          </div>

          <!-- Databases Section -->
          <div class="software-section" *ngIf="selectedResourceDetails.data.SoftwareData.databases.length > 0">
            <h6><i class="fas fa-database"></i> Databases</h6>
            <div class="software-badges">
              <span class="software-badge database-badge" *ngFor="let db of selectedResourceDetails.data.SoftwareData.databases">
                {{ db }}
              </span>
            </div>
          </div>

          <!-- Editors Section -->
          <div class="software-section" *ngIf="selectedResourceDetails.data.SoftwareData.editors.length > 0">
            <h6><i class="fas fa-edit"></i> Editors</h6>
            <div class="software-badges">
              <span class="software-badge editor-badge" *ngFor="let editor of selectedResourceDetails.data.SoftwareData.editors">
                {{ editor }}
              </span>
            </div>
          </div>

          <!-- Miscellaneous Section -->
          <div class="software-section" *ngIf="selectedResourceDetails.data.SoftwareData.misc.length > 0">
            <h6><i class="fas fa-plus-circle"></i> Miscellaneous</h6>
            <div class="software-badges">
              <span class="software-badge misc-badge" *ngFor="let misc of selectedResourceDetails.data.SoftwareData.misc">
                {{ misc }}
              </span>
            </div>
          </div>
        </div>

      </div>
      <div *ngIf="!loadingResourceDetails && !selectedResourceDetails" class="error-message">
        <i class="fas fa-exclamation-triangle"></i>
        <p>Failed to load resource details. Please try again.</p>
      </div>
    </div>
  </div>
</div>
